import RouteOverviewQuery from './RouteOverviewQuery';
import { selectFromRoutePaginatedDto } from '../../models';

export default selectFromRoutePaginatedDto()
  .hasNextPage
  .edges(b => b.node(RouteOverviewQuery))
  .toString();
